/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import * as API from '../../framework/API/api'
import { DAYS, ENTITYNAME, PLATFORMTYPE, PUBLISHING_SOURCE, TOAST_TYPES } from "../../framework/constant/constant";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { ArrayCell } from "../../framework/forms/helpercomponents/CustomGridCells/ArrayCell";
import { DateTimeCell } from "../../framework/forms/helpercomponents/CustomGridCells/DateCell";
import moment from "moment";
import { useTranslation } from "../../locale/useTranslation";
import AddRoundButton from "../../framework/forms/helpercomponents/buttons/AddRoundButton";
import EditRoundButton from "../../framework/forms/helpercomponents/buttons/EditRoundButton";
import DeleteRoundButton from "../../framework/forms/helpercomponents/buttons/DeleteRoundButton";
import SaveButton from "../../framework/forms/helpercomponents/buttons/SaveButton";
import CancelButton from "../../framework/forms/helpercomponents/buttons/CancelButton";
import { ConfirmDeleteAlert } from '../../ConfirmAlert';
import { utility } from "../../framework/utility/utilityProvider";
import RoundButton from "../../framework/forms/helpercomponents/buttons/RoundButton";
import MyMultiSelect from "../../components/MyMultiSelect";
import BossDialog from "../../components/BossDialog";
import CollectionSelection from "../../framework/forms/CollectionSelection";
import ToastNotification from "../../components/ToastNotification";

function MediaEpisodePublishingShortForm(props) {

    const mediaEpisodePublishings = props?.data?.filter(x => x?.IsSystemCreated != true) ?? [];

    let systemDealRight = props?.data?.find(x => x?.IsSystemCreated) ?? {};
    const isSystemCreated = systemDealRight?.IsSystemCreated ?? false;

    const getSystemDealRightMessage = () => {
        let systemDealRightMessage = "Unlimited Rights ";
        if (systemDealRight?.Channel?.length > 0) {
            systemDealRightMessage = systemDealRight?.Channel?.map((item) => item?.FullChannelName).join(", ");
            systemDealRightMessage = "Unlimited Channel Right for " + systemDealRightMessage + " Channel(s)";
        }
        return systemDealRightMessage;
    }

    const [channel, setChannel] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const lang = useTranslation();
    const [systemDealRightMessage, setSystemDealRightMessage] = useState("Unlimited Rights");
    const [isSystemCreatedCheck, setIsSystemCreatedCheck] = useState(false);
    const [showChannelGroups, setShowChannelGroups] = useState(false);
    const [isChannelWiseAllocation, setIsChannelWiseAllocation] = useState(false);

    const editIndex = useRef();

    let blankDataItem = {
        _id: undefined,
        SID: 0,
        PublishStartDate: moment(new Date()).utc().format('YYYY-MM-DDT00:00'),
        PublishStartDateTime: '00:00:00:00',
        PublishEndDate: moment(new Date()).add(1, 'd').utc().format('YYYY-MM-DDT23:59'),
        PublishEndDateTime: "23:59:59:24",
        PublishingSource: props.publishingSource,
        PlatformType: PLATFORMTYPE[0],
        Channel: [],
        Days: DAYS,
        IsExclusive: false,
        ExclusiveStartDate: '',
        ExclusiveEndDate: '',
        MediaCategory: props.mediaCategory ?? {},
        IsDefault: false,
        TBA: false,
        Archive: false,
    }

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [selectAllDays, setSelectAllDays] = useState(true);
    const [selectAllChannels, setSelectAllChannels] = useState(false);

    useEffect(() => {
        loadCombo();
        setSystemDealRightMessage(getSystemDealRightMessage());

        //SETTING THE DEFAULT DEAL RIGHT FOR THE PUBLISHING
        if (props.defaultDealRight && Object.keys(props.defaultDealRight).length > 0) {
            let publishing = props.defaultDealRight?.Publishing
            let daysArray = publishing.Days ? publishing.Days.split(",").map((item) => DAYS.find((x) => x.ID == item)) : [];

            setDataItem({
                ...publishing,
                PublishStartDate: moment(new Date(publishing.PublishStartDate)).utc().format('YYYY-MM-DDTHH:mm'),
                PublishStartDateTime: publishing.PublishStartDateTime ? utility.convertMilisecondsToStringWithFrames(publishing.PublishStartDateTime) : '00:00:00:00',
                PublishEndDate: moment(new Date(publishing.PublishEndDate)).utc().format('YYYY-MM-DDTHH:mm'),
                PublishEndDateTime: publishing.PublishEndDateTime ? utility.convertMilisecondsToStringWithFrames(publishing.PublishEndDateTime) : "23:59:59:24",
                ExclusiveStartDate: publishing.IsExclusive ? moment(new Date(publishing.ExclusiveStartDate)).format('YYYY-MM-DD') : '',
                ExclusiveEndDate: publishing.IsExclusive ? moment(new Date(publishing.ExclusiveEndDate)).format('YYYY-MM-DD') : '',
                Days: daysArray,
            })
        }

    }, [props.defaultDealRight]);

    const loadCombo = async () => {
        let channelRes = await API.getValidChannels(ENTITYNAME.Channel, { sort: { FullChannelName: 1 } });
        setChannel(channelRes.data);
    }

    const onChange = (e) => {

        if (e.target.name == "IsExclusive") {
            setDataItem({
                ...dataItem,
                IsExclusive: !dataItem.IsExclusive
            });
        } else if (e.target.name == "TBA") {
            setDataItem({ ...dataItem, TBA: !dataItem.TBA });
        } else if (e.target.name == "IsDefault") {
            setDataItem({ ...dataItem, IsDefault: !dataItem.IsDefault });
        }
        else if (e.target.name == "Days") {
            if (e.target.value.length == DAYS.length) {
                setDataItem({ ...dataItem, Days: DAYS });
                setSelectAllDays(true);
            }
            else {
                setDataItem({ ...dataItem, Days: e.target.value });
                setSelectAllDays(false);
            }
        }
        else if (e.target.name === "IsAllChannel") {
            const newValue = !selectAllChannels;

            setSelectAllChannels(newValue);
            setDataItem({
                ...dataItem,
                Channel: newValue ? channel : []
            });
        } else {
            let newObject = { ...dataItem, [e.target.name]: e.target.value };
            newObject.Channel.length === channel.length ? setSelectAllChannels(true) : setSelectAllChannels(false);
            setDataItem(newObject);
        }

    }

    const isValid = () => {

        if (!dataItem.Channel || dataItem.Channel.length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_channel_error_message });
            return false;
        }
        if (!dataItem.Days || dataItem.Days.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_atleast_one_days_error_message });
            return false;
        }

        if (!utility.isValidDate(dataItem.PublishStartDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_valid_start_date_error_message });
            return false;
        }
        if (!utility.isValidDate(dataItem.PublishEndDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_valid_end_date_error_message });
            return false;
        }
        if (dataItem.PublishStartDate > dataItem.PublishEndDate) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_start_date_smaller_than_end_date_media_episode_publishing_error_message });
            return false;
        }
        return true;
    }

    const editFormGrid = (data) => {

        let index = mediaEpisodePublishings.findIndex((x) => x == data);

        if (data?.IsSystemCreated) {
            let authorizeChannel = utility.isUserAuthorizeChannelRights(data.Channel);
            if (!authorizeChannel) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.you_are_not_authorized_to_edit_this_channel_error_message });
                return;
            }
        }

        if (props?.publishingSource != PUBLISHING_SOURCE.Series && data.PublishingSource == PUBLISHING_SOURCE.Series) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.you_are_not_authorized_to_edit_please_go_to_parent_series_error_message });
            return;
        }
        if (props?.publishingSource != PUBLISHING_SOURCE.Season && data.PublishingSource == PUBLISHING_SOURCE.Season) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.you_are_not_authorized_to_edit_please_go_to_series_error_message });
            return;
        }

        if (!props?.mediaCategory?.isLong || (data?.PublishingSource == props?.publishingSource) || data?.IsSystemCreated) {

            props.setOpenPublishingDialog(true);
            setEditMode(true);
            editIndex.current = index;

            let daysArray = data.Days ? data.Days.split(",").map((item) => DAYS.find((x) => x.ID == item)) : [];

            setDataItem({
                ...data,
                PublishStartDate: moment(new Date(data.PublishStartDate)).utc().format('YYYY-MM-DDTHH:mm'),
                PublishStartDateTime: data.PublishStartDateTime ? utility.convertMilisecondsToStringWithFrames(data.PublishStartDateTime) : '00:00:00:00',
                PublishEndDate: moment(new Date(data.PublishEndDate)).utc().format('YYYY-MM-DDTHH:mm'),
                PublishEndDateTime: data.PublishEndDateTime ? utility.convertMilisecondsToStringWithFrames(data.PublishEndDateTime) : "23:59:59:24",
                ExclusiveStartDate: data.IsExclusive ? moment(new Date(data.ExclusiveStartDate)).format('YYYY-MM-DD') : '',
                ExclusiveEndDate: data.IsExclusive ? moment(new Date(data.ExclusiveEndDate)).format('YYYY-MM-DD') : '',
                Days: daysArray,
            })
            setSelectAllDays(daysArray.length == DAYS.length ? true : false);
            setSelectAllChannels(data.Channel && data.Channel.length > 0 && data.Channel.length === channel.length ? true : false);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Selected Deal Right Can Be Edited From " + data.PublishingSource + " only." });
        }
    }

    const removePublishing = (data) => {

        let index = mediaEpisodePublishings.findIndex((x) => x == data);

        if (props?.publishingSource != PUBLISHING_SOURCE.Series && data.PublishingSource == PUBLISHING_SOURCE.Series) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.you_delete_this_deal_right_right_from_parent_series_only_media_episode_publishing_error_message });
            return;
        }
        if (props?.publishingSource != PUBLISHING_SOURCE.Season && data.PublishingSource == PUBLISHING_SOURCE.Season) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.you_delete_this_deal_right_right_from_series_only_media_episode_publishing_error_message });
            return;
        }

        if (data.PublishingSource != PUBLISHING_SOURCE.Contract) {
            if (data._id) props.handleRemovePublishingData(data);

            props.handlePublishings([
                ...mediaEpisodePublishings.slice(0, index),
                ...mediaEpisodePublishings.slice(index + 1, mediaEpisodePublishings.length)
            ]);
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.delete_successfully_grid_data_success_toast_message });
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.you_delete_this_deal_right_from_contract_only_media_episode_publishing_error_message });
        }
    }

    const onAddPublishing = () => {
        try {
            console.log('dede')

            // If channel-wise allocation is enabled, create one publishing entry per selected channel
            if (isChannelWiseAllocation && dataItem.Channel && dataItem.Channel.length > 0) {
                const publishingObjects = dataItem.Channel.map((ch) => ({
                    ...dataItem,
                    _id: undefined,
                    PublishStartDate: utility.getLocalDateTimeToUtcMiliseconds(new Date(dataItem.PublishStartDate)),
                    PublishStartDateTime: dataItem.TimeBound ? utility.convertStringWithFramesToMilliseconds(dataItem.PublishStartDateTime) : utility.convertStringWithFramesToMilliseconds('00:00:00:00'),
                    PublishEndDate: utility.getLocalDateTimeToUtcMiliseconds(new Date(dataItem.PublishEndDate)),
                    PublishEndDateTime: dataItem.TimeBound ? utility.convertStringWithFramesToMilliseconds(dataItem.PublishEndDateTime) : utility.convertStringWithFramesToMilliseconds("23:59:59:24"),
                    ExclusiveStartDate: dataItem.IsExclusive ? new Date(dataItem.ExclusiveStartDate).getTime() : 0,
                    ExclusiveEndDate: dataItem.IsExclusive ? new Date(dataItem.ExclusiveEndDate).getTime() : 0,
                    Days: dataItem.Days && dataItem?.Days?.map((item) => item.ID).join(","),
                    Channel: [{
                        _id: ch._id,
                        SID: ch.SID,
                        FullChannelName: ch.FullChannelName,
                    }]
                }));

                setSelectAllDays(true);
                console.log(publishingObjects);

                if (isValid()) {
                    props.handlePublishings([...mediaEpisodePublishings, ...publishingObjects]);
                    clearData();
                }
            }
            else {
                let publishingObject = {
                    ...dataItem,
                    _id: undefined,
                    PublishStartDate: utility.getLocalDateTimeToUtcMiliseconds(new Date(dataItem.PublishStartDate)),
                    PublishStartDateTime: dataItem.TimeBound ? utility.convertStringWithFramesToMilliseconds(dataItem.PublishStartDateTime) : utility.convertStringWithFramesToMilliseconds('00:00:00:00'),
                    PublishEndDate: utility.getLocalDateTimeToUtcMiliseconds(new Date(dataItem.PublishEndDate)),
                    PublishEndDateTime: dataItem.TimeBound ? utility.convertStringWithFramesToMilliseconds(dataItem.PublishEndDateTime) : utility.convertStringWithFramesToMilliseconds("23:59:59:24"),
                    ExclusiveStartDate: dataItem.IsExclusive ? new Date(dataItem.ExclusiveStartDate).getTime() : 0,
                    ExclusiveEndDate: dataItem.IsExclusive ? new Date(dataItem.ExclusiveEndDate).getTime() : 0,
                    Days: dataItem.Days && dataItem?.Days?.map((item) => item.ID).join(","),
                    Channel: dataItem.Channel && dataItem.Channel.map((item) => {
                        return {
                            _id: item._id,
                            SID: item.SID,
                            FullChannelName: item.FullChannelName,
                        }
                    })
                }
                setSelectAllDays(true);
                console.log(publishingObject);

                if (isValid()) //add validation
                {
                    props.handlePublishings([...mediaEpisodePublishings, publishingObject])
                    clearData();
                }
            }
        } finally {
            setIsChannelWiseAllocation(false);
        }
    }

    const editPublishing = () => {
        try {
            console.log("here in edit pub");

            const basePublishing = {
                ...dataItem,
                PublishStartDate: utility.getLocalDateTimeToUtcMiliseconds(new Date(dataItem.PublishStartDate)),
                PublishEndDate: utility.getLocalDateTimeToUtcMiliseconds(new Date(dataItem.PublishEndDate)),
                PublishStartDateTime: dataItem.TimeBound ? utility.convertStringWithFramesToMilliseconds(dataItem.PublishStartDateTime) : utility.convertStringWithFramesToMilliseconds('00:00:00:00'),
                PublishEndDateTime: dataItem.TimeBound ? utility.convertStringWithFramesToMilliseconds(dataItem.PublishEndDateTime) : utility.convertStringWithFramesToMilliseconds("23:59:59:24"),
                ExclusiveStartDate: dataItem.IsExclusive ? new Date(dataItem.ExclusiveStartDate).getTime() : 0,
                ExclusiveEndDate: dataItem.IsExclusive ? new Date(dataItem.ExclusiveEndDate).getTime() : 0,
                Days: dataItem.Days && dataItem.Days.map((item) => item.ID).join(","),
                isSystemCreated: isSystemCreated ?? false
            };

            if (isValid()) //add validation
            {
                if (isChannelWiseAllocation && dataItem.Channel && dataItem.Channel.length > 0) {
                    const publishingObjects = dataItem.Channel.map((ch) => ({
                        ...basePublishing,
                        _id: undefined,
                        Channel: [{ _id: ch._id, SID: ch.SID, FullChannelName: ch.FullChannelName }]
                    }));

                    const newData = [
                        ...mediaEpisodePublishings.slice(0, editIndex.current),
                        ...publishingObjects,
                        ...mediaEpisodePublishings.slice(editIndex.current + 1, mediaEpisodePublishings.length)
                    ];

                    props.handlePublishings(newData);

                    if (isSystemCreated) {
                        let getChannelName = publishingObjects.map(p => p.Channel[0]?.FullChannelName).join(", ");
                        let updateMessage = "Unlimited Channel Right for " + getChannelName + " Channel(s)";
                        setSystemDealRightMessage(updateMessage);
                    }
                }
                else {
                    const publishingObject = {
                        ...basePublishing,
                        _id: undefined,
                        Channel: dataItem?.Channel && dataItem.Channel?.map((item) => ({ _id: item._id, SID: item.SID, FullChannelName: item.FullChannelName }))
                    };

                    const newData = [...mediaEpisodePublishings.slice(0, editIndex.current), publishingObject, ...mediaEpisodePublishings.slice(editIndex.current + 1, mediaEpisodePublishings.length)];

                    props.handlePublishings(newData);

                    if (isSystemCreated) {
                        let getChannelName = publishingObject?.Channel?.map((item) => item?.FullChannelName).join(", ");
                        let updateMessage = "Unlimited Channel Right for " + getChannelName + " Channel(s)";
                        setSystemDealRightMessage(updateMessage);
                    }
                }

                clearData();
            }
        }
        finally {
            setIsChannelWiseAllocation(false);
        }
    }

    const clearData = () => {
        setDataItem(blankDataItem);
        setEditMode(false);
        props.setOpenPublishingDialog(false);
        setSelectAllDays(true);
        setSelectAllChannels(false);
        setIsSystemCreatedCheck(false);
    }

    const MyCommandCell = (props) => (
        <td style={{ display: "flex", padding: "0px" }} className="mt-1" >
            <EditRoundButton onClick={() => editFormGrid(props.dataItem)} />
            <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => removePublishing(props.dataItem), () => { })} />
        </td>
    )

    const allDaySelect = (e) => {
        if (e.target.checked) {
            setDataItem({ ...dataItem, Days: DAYS });
            setSelectAllDays(true);
        }
        else {
            setDataItem({ ...dataItem, Days: [] });
            setSelectAllDays(false);
        }
    }

    const handleChannelGroups = (groups = []) => {

        const linkedChannels = groups.flatMap(g => g.LinkedChannels || []);

        const uniqueChannels = Array.from(
            new Map(linkedChannels.map(ch => [ch._id, ch])).values()
        );

        setDataItem(prev => ({
            ...prev,
            Channel: uniqueChannels
        }));
        setSelectAllChannels(uniqueChannels.length === channel.length);

        setShowChannelGroups(false);
    };

    return (<>
        <div className="row" style={{ margin: "0px" }}>
            <div className="col-12">
                <div className="row">
                    <div className="col-12" style={{ width: '45vw' }}>
                        <AddRoundButton onClick={() => props.setOpenPublishingDialog(true)} />
                        {isSystemCreated && mediaEpisodePublishings.length == 0 && <RoundButton title={lang.add_channel_rights_button_tooltip} icon="caret-square-o-right" style={{ float: "right" }} onClick={() => { editFormGrid(systemDealRight); setIsSystemCreatedCheck(true); }} />}
                        <Grid data={mediaEpisodePublishings.filter((x) => x.PlatformType?.Description == PLATFORMTYPE[0]?.Description)} style={{ height: "30vh", marginTop: '5px', display: 'flex' }} resizable={true}>
                            <GridNoRecords> {systemDealRightMessage} </GridNoRecords>
                            <GridColumn cell={MyCommandCell} width={"80px"} />
                            <GridColumn field="Channel" format="FullChannelName" cell={ArrayCell} title={lang.channel_column} width={"250px"} />
                            <GridColumn field='PublishingSource' title={lang.source_column} width={"150px"} />
                            <GridColumn field="PublishStartDate" title={lang.start_date_column} cell={DateTimeCell} width={"200px"} />
                            <GridColumn field="PublishEndDate" title={lang.end_date_column} cell={DateTimeCell} width={"200px"} />
                            <GridColumn field="addBy.name" title={'Added By'} width={'125px'} />
                            <GridColumn field="modBy.name" title={'Modified By'} width={'125px'} />
                        </Grid>
                    </div>
                </div>
            </div>
            {props.openPublishingDialog &&
                <BossDialog
                    title={props.dialogtTitle ? props.dialogtTitle : lang.publishing_dialog_header}
                    onClose={clearData}
                    width="700px"
                >
                    <div className="row">
                        <div className="col-12">
                            {!editMode && <SaveButton onClick={() => onAddPublishing()} />}
                            {editMode && <SaveButton onClick={() => { editPublishing() }} />}
                            <CancelButton name={lang.cancel_button_text} btnColor={'danger'} onClick={clearData} />


                            {props.isNewMedia && <span >
                                <input type={"checkbox"} name={"IsDefault"}
                                    onChange={(e) => onChange(e)}
                                    value={dataItem.IsDefault}
                                    checked={dataItem.IsDefault}
                                    style={{ margin: "5px 0px 0px 25px", width: '15px', height: '15px' }}
                                    title="Set default deal right for future use"
                                />
                                <label className="pl-1 " style={{ fontWeight: "bold" }} title="Set default deal right for future use" >{lang.set_as_default_label}</label>
                            </span>}

                            {dataItem.Channel.length > 1 && <span >
                                <input type={"checkbox"} name={"isChannelWiseAllocation"}
                                    onChange={(e) => setIsChannelWiseAllocation(!isChannelWiseAllocation)}
                                    value={isChannelWiseAllocation}
                                    checked={isChannelWiseAllocation}
                                    style={{ margin: "5px 0px 0px 25px", width: '15px', height: '15px' }}
                                    title="Set default deal right for future use"
                                />
                                <label className="pl-1 " style={{ fontWeight: "bold" }} title="Set default deal right for future use" >Channel-wise Allocation</label>
                            </span>}

                            <div className="row" style={{ margin: '1px' }}>
                                <div className="col-12 mt-4" >
                                    <div className="row">
                                        <div className="col-6 form-group">
                                            <div className="d-flex justify-content-between align-items-center mb-1">
                                                <label className="mb-0 fw-semibold">
                                                    {lang.channel_label} <span className="text-danger">*</span>
                                                </label>
                                                <div className="d-flex align-items-center">
                                                    <span className="me-1">{lang.select_all_label}</span>
                                                    <input
                                                        type="checkbox"
                                                        name="IsAllChannel"
                                                        className="ml-1"
                                                        value={selectAllChannels}
                                                        checked={selectAllChannels}
                                                        onChange={onChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <div style={{ flex: 1 }}>
                                                    <MyMultiSelect
                                                        style={{ backgroundColor: "white", width: "100%" }}
                                                        data={channel}
                                                        name="Channel"
                                                        textField="FullChannelName"
                                                        dataItemKey="_id"
                                                        value={dataItem.Channel}
                                                        onChange={onChange}
                                                    />
                                                </div>
                                                <button
                                                    type="button"
                                                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-success ms-2"
                                                    style={{ width: "28px", height: "28px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginLeft: "10px" }}
                                                    title={lang.select_channel_groups_tooltip}
                                                    onClick={() => setShowChannelGroups(true)}
                                                >
                                                    <i className="fa fa-ellipsis-h" aria-hidden="true" />
                                                </button>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <label htmlFor="">{lang.days_label} *</label>
                                            <span className="float-right">{lang.select_all_label}
                                                <input
                                                    type={"checkbox"}
                                                    name={"SelectAll"}
                                                    className="ml-1"
                                                    onChange={allDaySelect}
                                                    checked={selectAllDays}
                                                    value={selectAllDays}
                                                />
                                            </span>
                                            <MyMultiSelect
                                                style={{ backgroundColor: "white" }}
                                                data={DAYS}
                                                name="Days"
                                                textField="Name"
                                                dataItemKey="ID"
                                                value={dataItem.Days}
                                                onChange={onChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6 form-group">
                                            <label htmlFor="">{lang.start_date_label} *</label>
                                            <input
                                                type="datetime-local"
                                                className="form-control form-control-sm"
                                                name="PublishStartDate"
                                                value={dataItem.PublishStartDate}
                                                onChange={(e) => onChange(e)}
                                                disabled={isSystemCreatedCheck}
                                            />
                                        </div>

                                        <div className="col-6 form-group">
                                            <label htmlFor="">{lang.end_Date_label} *</label>
                                            <input
                                                disabled={dataItem.TBA || isSystemCreatedCheck}
                                                type="datetime-local"
                                                className="form-control form-control-sm"
                                                name="PublishEndDate"
                                                value={dataItem.PublishEndDate}
                                                onChange={(e) => onChange(e)}
                                            />
                                        </div>
                                    </div>
                                    <div className="row form-group">
                                        <div className="col-3">
                                            <input name="TBA" type="checkbox" value={dataItem.TBA} checked={dataItem.TBA} onChange={onChange} />
                                            <label className='ml-1'>{lang.tba_label}</label>
                                        </div>
                                        <div className="col-3">
                                            <input
                                                type={"checkbox"}
                                                name={"IsExclusive"}
                                                onChange={(e) => onChange(e)}
                                                value={dataItem.IsExclusive}
                                                checked={dataItem.IsExclusive}
                                                disabled={isSystemCreatedCheck}
                                            />
                                            <label className="pl-1">{lang.exclusive_label}</label>
                                        </div>
                                        {dataItem.IsExclusive && <div className="col-3">
                                            <label htmlFor="">{lang.exclusive_start_date_label} *</label>
                                            <input type={'date'} name={"ExclusiveStartDate"} value={dataItem.ExclusiveStartDate} onChange={onChange} max={dataItem.ExclusiveEndDate} className="form-control-sm"
                                                style={{ width: '100%', backgroundColor: 'white', border: '1px solid lightgrey', borderRadius: '5px', paddingLeft: '5px' }} label={lang.start_date_label}
                                            />
                                        </div>}
                                        {dataItem.IsExclusive && <div className="col-3">
                                            <label htmlFor="">{lang.exclusive_end_date_label} *</label>
                                            <input type={'date'} name={"ExclusiveEndDate"} onChange={onChange} value={dataItem.ExclusiveEndDate} min={dataItem.ExclusiveStartDate} className="form-control-sm"
                                                style={{ width: '100%', backgroundColor: 'white', border: '1px solid lightgrey', borderRadius: '5px', paddingLeft: '5px' }} label={lang.end_Date_label}
                                            />
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </BossDialog>}
            {showChannelGroups && <CollectionSelection setDataList={handleChannelGroups} closeForm={() => setShowChannelGroups(false)} entityname={ENTITYNAME.ChannelGroups} width={"50vw"} title={lang.select_channel_groups_collection_header} addButtonTitle={lang.select_collection_button_text} />}
        </div>
    </>)
}

export default MediaEpisodePublishingShortForm;